import { render, staticRenderFns } from "./MatchSignupStaffConfigEdit.vue?vue&type=template&id=58013476&"
import script from "./MatchSignupStaffConfigEdit.vue?vue&type=script&lang=js&"
export * from "./MatchSignupStaffConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports